import { useMutation } from '@apollo/client/react/hooks';
import {
  CreateCustomerDisplayInput,
  UpdateCustomerDisplayInput,
} from '@oolio-group/domain';
import { useCallback } from 'react';
import {
  CREATE_CUSTOMER_DISPLAY,
  UPDATE_CUSTOMER_DISPLAY,
} from '../../graphql/customerDisplay';

export function useCustomerDisplay() {
  const [createCdsOnDevice, cdsResponse] = useMutation(CREATE_CUSTOMER_DISPLAY);
  const [updateCdsOnDeviceMutation, updateCdsResponse] = useMutation(
    UPDATE_CUSTOMER_DISPLAY,
  );

  const onCreateCdsOnDevice = useCallback(
    async (input: CreateCustomerDisplayInput) => {
      return await createCdsOnDevice({
        variables: {
          input: {
            deviceId: input.deviceId,
            name: input.name,
            deviceUuid: input.deviceUuid,
            isPaired: input.isPaired,
            appVersion: input.appVersion,
            platform: input.platform,
          } as CreateCustomerDisplayInput,
        },
      });
    },
    [createCdsOnDevice],
  );

  const onUpdateCdsOnDevice = useCallback(
    async (input: UpdateCustomerDisplayInput) => {
      return await updateCdsOnDeviceMutation({
        variables: {
          input: {
            id: input.id,
            name: input.name,
            appVersion: input.appVersion,
            platform: input.platform,
          } as UpdateCustomerDisplayInput,
        },
      });
    },
    [updateCdsOnDeviceMutation],
  );

  return {
    createCdsOnDevice: onCreateCdsOnDevice,
    updateCdsOnDevice: onUpdateCdsOnDevice,
    error: cdsResponse?.error ?? updateCdsResponse?.error,
    customerDisplay: cdsResponse.data?.createCustomerDisplayOnDevice,
    loading: cdsResponse.loading || updateCdsResponse.loading,
  };
}
